import { memo } from 'react';
import { LETTRE_HEX } from '../../utils/qcmTheme';

/**
 * Confettis « projo » : pluie LENTE plein écran (chute 4,5-7 s, balancement,
 * rotation douce, fondu en fin de course) — pensée pour être vue de loin.
 * Variation déterministe par index (pas de Math.random).
 *
 * @param {number}  [pieces=30] densité de la pluie
 * @param {boolean} [boucle=false] true = pluie continue ; false = une seule
 *                  chute (~7 s) puis les pièces finissent invisibles
 * @param {number}  [taille=1] multiplicateur de taille des pièces
 * @param {boolean} [centre=false] true = concentre la chute sur le tiers
 *                  central de l'écran (effet burst au-dessus du podium)
 */
const COLORS = [LETTRE_HEX.A, LETTRE_HEX.B, LETTRE_HEX.C, LETTRE_HEX.D, '#FFB938', '#22c55e'];

const ProjConfetti = memo(function ProjConfetti({ pieces = 30, boucle = false, taille = 1, centre = false }) {
  return (
    <div className="pointer-events-none fixed inset-0 overflow-hidden z-[5]" aria-hidden="true">
      {Array.from({ length: pieces }, (_, i) => {
        const spread = (i * 41 + 13) % 100;
        const left = centre ? 30 + spread * 0.4 : spread; // centré : 30-70 %
        const color = COLORS[i % COLORS.length];
        const dur = 4.5 + ((i * 17) % 25) / 10;   // 4,5–7 s
        const delay = ((i * 23) % 18) / 10;        // 0–1,7 s
        const w = (8 + (i % 4) * 3) * taille;
        const sway = 30 + ((i * 11) % 40);         // amplitude du balancement (px)
        return (
          <span
            key={i}
            className="proj-confetti-piece"
            style={{
              left: `${left}%`,
              background: color,
              width: w,
              height: w * 1.5,
              '--sway': `${i % 2 === 0 ? sway : -sway}px`,
              animationDuration: `${dur}s`,
              animationDelay: `${delay}s`,
              animationIterationCount: boucle ? 'infinite' : 1,
            }}
          />
        );
      })}
    </div>
  );
});

export default ProjConfetti;
